(ns ycweb.app.pos.menu
  (:require
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.components.header :as header]
   [ycweb.util.core :as u]
   [ycweb.components.grid :as grid]
   [ycweb.components.common :as cmn]
   [ycweb.components.transitions :as t]
   [ycweb.components.flow :as flow]
   [util.transform :as trf]))

;; TODO: these menu links need to be converted to data so that we can filter by permissions
;; and return dynamically from the server.


(defn pos-menus [app-atom]
  (let [store-name (cmn/curact app-atom [:selected-warehouse :displayname])
        price-change-alerts (cmn/curact app-atom [:alerts :price-change])
        price-change-alert? (> (or (:qty price-change-alerts) 0) 0)
        keep-aside-alerts (cmn/curact app-atom [:alerts :keep-aside])
        keep-aside-alert? (or (:inbound? keep-aside-alerts) (:expired? keep-aside-alerts))]
    (remove nil?
      [{:label "Sell" :icon :cash :icon-size :3-2 :background :mint-green
        :select-fn #(grid/dispatch-action app-atom :sell/start-cart {})}

       {:label "Order Collections" :icon :package :background :purple
        :select-fn #(t/transition-next app-atom :collections)}

       {:label "Returns & Repairs" :icon :return :background :blue
        :select-fn #(t/transition-next app-atom :returns)}

       {:label "Pay for Registry" :icon :ring
        :select-fn #(grid/dispatch-action app-atom :payregistry/start {}) :side-only true}

       {:label "Price Tags" :icon :price-tag :background :yellow
        :alert? price-change-alert?
        :select-fn #(t/transition-next app-atom :pricetags)}

       {:label "Keep Aside" :icon :keep-aside :background :asphalt-light
        :alert? keep-aside-alert?
        :select-fn #(t/transition-next app-atom :keepaside)}

       {:label "Query Item" :icon :help :background :plum-light
        :select-fn #(t/transition-next app-atom :queryitem)}

       {:label "Voucher" :icon :gift-card
        :select-fn #(t/transition-next app-atom :voucher/code) :side-only true}

       {:label "Stocktake" :icon :stocktake :background :yellow
        :select-fn #(t/transition-next app-atom :stocktake/stocktake-main)}

       #_{:label "Parked Orders" :icon :history :background :yellow
          :select-fn #(t/transition-next app-atom :parked)}

       {:label "Shrink & Grow" :icon :download :background :yellow
        :select-fn #(t/transition-next app-atom :stock)}

       (when (and (= store-name "Westlake") (cmn/has-permission? app-atom "SiteAdmin:Weber:Shop:Admin"))
         {:label "Seconds Pricing" :icon :price-tag :background :purple
          :select-fn #(t/transition-next app-atom :secondspricing/item-scan)})

       (when (cmn/has-permission? app-atom "SiteAdmin:Blitz:Merchandising")
         {:label "Merchandising" :icon :camera :background :yellow
          :select-fn #(t/transition-next app-atom :merchandising/choose-type)})

       (when (cmn/has-permission? app-atom "SiteAdmin:Teams:Development")
         {:label "Move Stock" :icon :package-out :background :asphalt-light
          :select-fn #(t/transition-next app-atom :unpacking/fromlocation)})

       {:label "Transfers" :icon :truck-in :background :yellow
        :select-fn #(t/transition-next app-atom :transfers/select-option)}

       {:label "Prereceiving" :icon :truck-check :background :yellow
        :select-fn #(t/transition-next app-atom :prereceiving/choose-type)}

       {:label "Receiving" :icon :package-in :background :yellow
        :select-fn #(t/transition-next app-atom :receiving/choose-type)}

       {:label "Collection Linking" :icon :package-link :background :purple
        :select-fn #(t/transition-next app-atom :collectionlinking/packbox)}

       {:label "Lock POS" :icon :lock
        :select-fn #(t/transition-next app-atom :lock)}

       (when (cmn/has-permission? app-atom "SiteAdmin:Teams:Development")
         {:label "Camera" :icon :camera
          :select-fn #(grid/dispatch-action app-atom :camera {})})

       (when
         (or
           (cmn/has-permission? app-atom "SiteAdmin:Store:Manager")
           (cmn/has-permission? app-atom "SiteAdmin:Store:Regional Manager"))
         {:label "Store Admin" :icon :user :background :asphalt-light
          :select-fn #(t/transition-next app-atom :admin-management)})

       {:label "Log Out" :icon :logout :text-style "negative" :side-menu-icon-size :3-3
        :select-fn #(grid/dispatch-action app-atom :login/logout {})}])))

(defn blitz-menus [app-atom]
  [{:label "Warehouse Hygiene" :icon :download :background :mint-green
    :select-fn #(grid/dispatch-action app-atom :hygiene/menu {})}

   {:label "Picking" :icon :package-in :background :purple
    :select-fn #(grid/dispatch-action app-atom :picking/pickingtype {})}

   {:label "Unpicking" :icon :package-out :background :yellow
    :select-fn #(grid/dispatch-action app-atom :unpicking/start {})}

   {:label "Packing" :icon :download :background :blue
    :select-fn #(t/transition-next app-atom :packing/choose-type)}

   {:label "Move Stock" :icon :package-out :background :asphalt-light
    :select-fn #(t/transition-next app-atom :unpacking/fromlocation)}

   {:label "Receiving" :icon :package-in :background :plum-light
    :select-fn #(t/transition-next app-atom :receiving/choose-type)}

   {:label "Packer Running" :icon :package :background :plum-light
    :select-fn #(grid/dispatch-action app-atom :packer-running/areas {})}

   {:label "Prereceiving" :icon :truck-check :background :yellow
    :select-fn #(t/transition-next app-atom :prereceiving/choose-type)}

   {:label "Move Bins" :icon :package-out :background :plum-light
    :select-fn #(t/transition-next app-atom :movebins/location-scan)}

   {:label "Shipping" :icon :truck-out :background :blue
    :select-fn #(t/transition-next app-atom :shipping/choose-type)}

   {:label "Manufacturing" :icon :cart :background :blue
    :select-fn #(grid/dispatch-action app-atom :manufacturing/list-orders {})}

   {:label "Keep Aside" :icon :package :background :blue
    :select-fn #(t/transition-next app-atom :keepaside/choose-type)}

   {:label "Build Boxes" :icon :package :background :yellow
    :select-fn #(t/transition-next app-atom :buildboxes/buildboxes-printer-scan)}

   (when (cmn/has-permission? app-atom "SiteAdmin:Blitz:Merchandising")
     {:label "Merchandising" :icon :camera :background :yellow
      :select-fn #(t/transition-next app-atom :merchandising/choose-type)})

   {:label "Aftersales" :icon :download :background :mint-green
    :select-fn #(grid/dispatch-action app-atom :aftersales/menu {})}

   {:label "Shrink" :icon :download :background :yellow
    :select-fn #(t/transition-next app-atom :shrink/location-scan)}

   {:label "Manual Transfers" :icon :truck-out :background :yellow
    :select-fn #(grid/dispatch-action app-atom :manualtransfers/warehouse-list {})}

   {:label "Card Linking" :icon :package :background :blue
    :select-fn #(grid/dispatch-action app-atom :cardlinking/refresh-cache {})}

   (when (cmn/has-permission? app-atom "SiteAdmin:Weber:Shop:Admin")
     {:label "Seconds Pricing" :icon :price-tag :background :purple
      :select-fn #(t/transition-next app-atom :secondspricing/item-scan)})

   {:label "Lock" :icon :lock
    :select-fn #(t/transition-next app-atom :lock)}

   (when
    (or
      (cmn/has-permission? app-atom "SiteAdmin:Weber")
      (cmn/has-permission? app-atom "SiteAdmin:Weber:Reports"))
     {:label "Warehouse Admin" :icon :user :background :asphalt-light
      :select-fn #(t/transition-next app-atom :admin-management)})

   {:label "Log Out" :icon :logout :text-style "negative" :side-menu-icon-size :3-3
    :select-fn #(grid/dispatch-action app-atom :login/logout {})}])

(defn select-menus [app-atom]
  (->>
    (if (-> @app-atom :blitz? trf/toboolean)
      (blitz-menus app-atom)
      (pos-menus app-atom))
    (remove nil?)))


(rum/defc main-item [{:keys [label icon icon-size background select-fn alert?]}]
  [:li.homescreen-menu__item
   {:style {:height "34%"}}
   [:a
    {:class (u/bem :tile [:has-shadow] :u-angled-background []
              (when background (keyword (str "u-bg-" (name background)))) [])
     ;; TODO: This should _not_ be needed, don't know what's going on here.
     :on-click select-fn}
    [:span.tile__content
     [:span.tile__icon-wrapper
      [:i.tile__icon
       {:class (u/bem :icon [(or icon-size :2-2) icon :large :block])}]]
     [:span.tile__text label]
     (when alert?
       [:div.tile__alert
        [:i.icon.icon--block.icon--error.icon--3-2]])]]])

;; ========= Default Store Modal ===========================
(rum/defc default-warehouse-modal-body < rum/reactive [app-atom _]
  (let [login-atom (rum/cursor app-atom :login)
        warehouse-list (cmn/curact app-atom :warehouse-list)
        warehouse-id (:warehouse_id (cmn/curval login-atom))
        login-warehouse (first (filter #(= warehouse-id (:warehouse-id %)) warehouse-list))

        default-warehouse-names
        (str/join
          " / "
          (->>
            (filter :default warehouse-list)
            (map :displayname)))]

    [:div
     [:h3
      {:class (u/bem :heading [:medium-large])}
      "Are you sure?"]
     [:p "You are logged in to " (:displayname login-warehouse)

      ", but it looks like you are located at "
      [:br]
      (or (u/presence default-warehouse-names) "an unknown location") "."]]))

(rum/defc default-warehouse-modal-footer [app-atom]
  (grid/button-row
    {:left-text "Continue"
     :left-fn #(grid/dispatch-modal-action app-atom :menu/default-warehouse-modal-confirm)
     :left-no-icon true
     :right-text "Change Store"
     :right-fn #(grid/dispatch-modal-action app-atom :menu/default-warehouse-modal-change)
     :right-no-icon true}))

(defmethod grid/modal-config :menu/default-warehouse-modal [_ _ _]
  {:body default-warehouse-modal-body
   :footer default-warehouse-modal-footer
   :modal-type :alert})

(defmethod grid/action :menu/default-warehouse-modal-confirm [app-atom _ _]
  (grid/close-modal app-atom))

(defmethod grid/action :menu/default-warehouse-modal-change [app-atom _ _]
  (grid/close-modal app-atom)
  (t/transition-next app-atom :login))

(defmethod grid/action :menu/open-default-warehouse-warning [app-atom _ _]
  (grid/open-modal app-atom :menu/default-warehouse-modal {}))


;; ========= Main Screen ===========================
(rum/defc main-screen < rum/reactive
  [app-atom menu-items]
  (let [menu-atom (rum/cursor-in app-atom [:menu])]
    [:div
     {:class (u/bem :page-body [:homescreen])}

     (header/header app-atom "Get Started" {})
     (header/menu-overlay menu-atom)
     (header/menu app-atom menu-items)

     [:div.homescreen-content
      (into
        [:ul.homescreen-menu]
        (->>
          menu-items
          (remove :side-only)
          (take 6)
          (map main-item)))]]))

(defmethod flow/render-screen :main-menu [app-atom _]
  (main-screen app-atom (select-menus app-atom)))
